import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { parseCurlCommand } from "../utils/parseCurl";

const StyledButton = styled(Button)(() => ({
  backgroundColor: "#FF6B00",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#E65100",
    color: "#FFFFFF",
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFB380",
  },
}));

const CancelButton = styled(Button)(() => ({
  color: "#FF6B00",
  borderColor: "#FF6B00",
  "&:hover": {
    backgroundColor: "#FFF5EB",
    borderColor: "#FF6B00",
  },
}));

const CurlImportDialog = ({ open, onClose, onImport }) => {
  const [curlCommand, setCurlCommand] = useState("");
  const [error, setError] = useState(null);

  const handleCurlChange = (e) => {
    setCurlCommand(e.target.value);
    setError(null);
  };

  const handleImport = () => {
    try {
      if (!curlCommand.trim()) {
        setError("Please enter a cURL command");
        return;
      }

      const parsedData = parseCurlCommand(curlCommand);

      // Validate parsed data
      if (!parsedData.url) {
        setError("Could not parse URL from the cURL command");
        return;
      }

      onImport(parsedData);
      setCurlCommand("");
      onClose();
    } catch (err) {
      setError(`Error parsing cURL command: ${err.message}`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Import from cURL</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Paste a cURL command below to automatically populate the API request form.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <TextField
            fullWidth
            multiline
            rows={6}
            value={curlCommand}
            onChange={handleCurlChange}
            placeholder={`curl -X POST 'https://api.example.com/v1/data?param=value' -H 'Content-Type: application/json' -d '{\"key\":\"value\"}'`}
            variant="outlined"
            sx={{
              fontFamily: "monospace",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#FFE0B2",
                },
                "&:hover fieldset": {
                  borderColor: "#FFB74D",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#FF6B00",
                },
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <CancelButton onClick={onClose} variant="outlined">
          Cancel
        </CancelButton>
        <StyledButton onClick={handleImport} variant="contained">
          Import
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
};

export default CurlImportDialog;
